import { createRouter, createWebHistory } from 'vue-router'
import { useStore } from '@/store'

import IndexPage from '@/pages/IndexPage.vue'
import LoginPage from '@/pages/LoginPage.vue'
import AdminDashboard from '@/pages/AdminDashboard.vue'

const routes = [
  {
    path: '/',
    component: IndexPage,
    meta: {
      title: 'Swish - Astrological Commentary',
    },
  },
  {
    path: '/login',
    component: LoginPage,
    meta: {
      title: 'Swish - Astrological Commentary | Login',
    },
  },
  {
    path: '/admin',
    component: AdminDashboard,
    meta: {
      title: 'Swish - Astrological Commentary | Dashboard',
      requiresAuth: true,
      requiresAdmin: true
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const store = useStore()

  // Check if the route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // If the user is not logged in, redirect to the login page
    if (!store.jwtToken) {
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
  }

  // Check if the route requires admin privileges
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    // If the user is not an admin, redirect to the home page
    if (!store.isAdmin) {
      next({ path: '/' })
      return
    }
  }

  next()
})

export default router
